import { history } from "../../../types/history";
import { Nullable } from "../../../types/common";
import { PAGES } from "../types/pages.constant";
import { INotification } from "../../../types/notification/inotification.interface";
import { getNotificationResourceRoute } from "../types/notification-route-handler/notification-route-handler.functions";

const PostLoginQueryParam = "pld";

export function goToLogin() {
  window.location.href = `/login${getPostLoginDestinationQuery()}`;
}

export function goToPostLoginDestination() {
  const pld = getPostLoginDestination();

  if (pld === "/forgot-password") {
    return goToCampaignBriefs();
  }
  return pld ? goTo(pld) : goToCampaignBriefs();
}

export function setFragment(fragment: string) {
  history.push(`${history.location.pathname}#${fragment}`);
}

export function goTo(path: string) {
  history.push(path);
}

export function goToCampaignBrief(id: number) {
  history.push(`${PAGES.CAMPAIGN_BRIEF.URL}/${id}`);
}

export function goToCampaignBriefs() {
  history.push("/campaign-briefs");
}

export function goToExecutionBrief(id: number) {
  history.push(`${PAGES.EXECUTION_BRIEF.URL}/${id}`);
}

export function goToExecutionBriefs() {
  history.push("/multi-channel-briefs");
}

export function goToFlyer(flyerId: number) {
  history.push(`/design-layouts/${flyerId}`);
}

export function goToFlyerPages(flyerId: number) {
  history.push(`/design-layouts/${flyerId}#pages`);
}

export function goToFlyerPage(flyerId: number, pageId: number) {
  history.push(`/design-layouts/${flyerId}/page/${pageId}`);
}

export function goToFlyerAddPage(flyerId: number) {
  history.push(`/design-layouts/${flyerId}/add-page`);
}

export function navigateToNotificationResource(notification: INotification) {
  const route = getNotificationResourceRoute(notification);
  if (route) {
    history.push(route);
  }
}

function isRootOrLogin(url: URL): boolean {
  return url.pathname === "/" || url.pathname === "/login";
}

function getPostLoginDestinationQuery(): string {
  const url = getCurrentUrl();
  return isRootOrLogin(url) ? "" : `?${PostLoginQueryParam}=${btoa(url.pathname)}`;
}

function getPostLoginDestination(): Nullable<string> {
  const value = getCurrentUrl().searchParams.get(PostLoginQueryParam);
  return value ? atob(value) : null;
}

function getCurrentUrl(): URL {
  return new URL(window.location.href);
}

export function jumpTo(anchorName: string) {
  const element = document.getElementById(anchorName);
  if (element) element.focus();
}
